<template>
  <div class="dashboard">
    <dashboard-campaign syndicat="unpf"></dashboard-campaign>
  </div>
</template>

<script>
import DashboardCampaign from "./DashboardCampaign";

export default {
  name: "campaignUnpf",
  components: { DashboardCampaign },

  methods: {},
  mounted() {}
};
</script>

<style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0 !important;
  }
}
</style>
